import { render, staticRenderFns } from "./DialogDetailCoutArticle.vue?vue&type=template&id=6f5c500d"
import script from "./DialogDetailCoutArticle.vue?vue&type=script&lang=js"
export * from "./DialogDetailCoutArticle.vue?vue&type=script&lang=js"
import style0 from "./DialogDetailCoutArticle.vue?vue&type=style&index=0&id=6f5c500d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports